<template>
  <AdminForm :config="config" :form="form" :isBusy="isBusy" :options="options" @submit:create:success="postFile"
    @submit:update:success="postFile"></AdminForm>
</template>

<script>
import AdminForm from "@/components/Global/AdminForm";
import config from "./config";

export default {
  name: "ExternalMaintenanceForm",
  components: {
    AdminForm
  },
  props: ["id_to_edit", "params"],
  data() {
    return {
      config: config,
      form: {
        start_date: this.$moment().format("YYYY-MM-DD"),
        end_date: null,
        provider_id: null,
        type_slug: null,
        additional_informations: null,
        price: null,
        stored_files: []
      },
      isBusy: false,
      initialForm: {}
    };
  },
  computed: {
    options: function() {
      return {
        provider_id_options: this.$store.getters["company/getByTypeCode"]([
          "FRNI",
          "PRST"
        ]).selectOptions("id", "name"),
        reference_id_options: this.$store.getters["reference/getAll"].filter((item) => ['reference-en-stock','reference-en-location','reference-vendu','reference-en-attente-de-maintenance', 'reference-maintenance-planifiee', 'reference-en-maintenance-externe'].includes(item.status.status_slug)).selectOptions("id", ["product.name", " - ", "internal_code"]),
        type_slug_options: this.$store.getters[
          config.storeNamespace + "/getTypes"
        ]
      };
    }
  },
  mounted() {
    let self = this;

    // Edition
    const id =
      this.$route.name == config.editRouteName && this.$route.params.id
        ? this.$route.params.id
        : this.id_to_edit || null;

    if (id) {
      this.isBusy = true;
      this.$store
        .dispatch(config.storeNamespace + "/getItem", {
          id: id,
          wait: true
        })
        .then(() => {

          let item = _.cloneDeep(
            this.$store.getters[config.storeNamespace + "/getItem"](id)
          );
          this.form = {
            ...item,
            reference_id: item.reference ? item.reference.id : null,
            start_date: item.start_date
              ? this.$moment(item.start_date).format("YYYY-MM-DD")
              : this.$moment().format("YYYY-MM-DD"),
            end_date: item.end_date
              ? this.$moment(item.end_date).format("YYYY-MM-DD")
              : null,
            provider_id: item.provider ? item.provider.id : null,
            invoice_id: item.stored_files.filter(i => (i.type_slug == 'invoice')).length > 0 ? item.stored_files.filter(i => (i.type_slug == 'invoice'))[0].id : null,
            invoice: item.stored_files.filter(i => (i.type_slug == 'invoice')).length > 0 ? item.stored_files.filter(i => (i.type_slug == 'invoice'))[0].file : null,
            purchase_order_id: item.stored_files.filter(i => (i.type_slug == 'purchase_order')).length > 0 ? item.stored_files.filter(i => (i.type_slug == 'purchase_order'))[0].id : null,
            purchase_order: item.stored_files.filter(i => (i.type_slug == 'purchase_order')).length > 0 ? item.stored_files.filter(i => (i.type_slug == 'purchase_order'))[0].file : null,
            control_certificate_id: item.stored_files.filter(i => (i.type_slug == 'external-maintenance-certificate')).length > 0 ? item.stored_files.filter(i => (i.type_slug == 'external-maintenance-certificate'))[0].id : null,
            control_certificate: item.stored_files.filter(i => (i.type_slug == 'external-maintenance-certificate')).length > 0 ? item.stored_files.filter(i => (i.type_slug == 'external-maintenance-certificate'))[0].file : null,
            stored_files: item.stored_files
              ? item.stored_files.filter((i) => i.type_slug == "external-maintenance-attachment")
              : [],
          };
          // On sauvegarde les données initiales, donc avant modification dans le form, pour ensuite
          // les utiliser dans la gestion des fichiers joints
          this.initialForm = _.cloneDeep(this.form);
          this.isBusy = false;
        });
    } else {
      this.form = { ...this.form, ...this.params };
    }

    this.$store.dispatch("reference/getAllForSelect");
    this.$store.dispatch("company/getAllForSelect");
  },
  methods: {

    postFile(response) {

      const external_maintenance_id = response.data.object.id;

      // Gestion de la facture supprimée
      // On compare les données du formulaire avant modification avec mes données modifiées
      // pour identifier les fichiers supprimés
      if (this.initialForm.invoice && this.initialForm.invoice_id) {
        // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
        if (this.form.invoice != this.initialForm.invoice) {
          this.$store
            .dispatch("stored_file/deleteItem", this.initialForm.invoice_id)
            .then((response) => {
              this.$store.dispatch(config.storeNamespace + "/getItem", {
                id: external_maintenance_id,
              });
            });
        }
      }

      // Si il ya une facture
      if (this.form.invoice && typeof this.form.invoice == "object" && this.form.invoice.type) {
        // Si il ne s'agit pas d'un fichier déjà présent
        let item = {
          external_maintenance_id: response.data.object.id,
          type_slug: "invoice",
          format: this.form.invoice.type,
          file: this.form.invoice,
        };

        this.$store.dispatch("stored_file/addItem", item).then((response) => {
          this.$store.dispatch(config.storeNamespace + "/getItem", {
            id: external_maintenance_id,
          });
        });
      }

      /////

      // Gestion bon de commande SAP supprimé
      // On compare les données du formulaire avant modification avec mes données modifiées
      // pour identifier les fichiers supprimés
      if (this.initialForm.purchase_order && this.initialForm.purchase_order_id) {
        // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
        if (this.form.purchase_order != this.initialForm.purchase_order) {
          this.$store
            .dispatch("stored_file/deleteItem", this.initialForm.purchase_order_id)
            .then((response) => {
              this.$store.dispatch(config.storeNamespace + "/getItem", {
                id: external_maintenance_id,
              });
            });
        }
      }

      // Si il y a un bon de commande
      if (this.form.purchase_order && typeof this.form.purchase_order == "object" && this.form.purchase_order.type) {
        // Si il ne s'agit pas d'un fichier déjà présent
        let item = {
          external_maintenance_id: response.data.object.id,
          type_slug: "purchase_order",
          format: this.form.purchase_order.type,
          file: this.form.purchase_order,
        };

        this.$store.dispatch("stored_file/addItem", item).then((response) => {
          this.$store.dispatch(config.storeNamespace + "/getItem", {
            id: external_maintenance_id,
          });
        });
      }


      /////
      if (this.initialForm.control_certificate && this.initialForm.control_certificate_id) {
        // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
        if (this.form.control_certificate != this.initialForm.control_certificate) {
          this.$store
            .dispatch("stored_file/deleteItem", this.initialForm.control_certificate_id)
            .then((response) => {
              this.$store.dispatch(config.storeNamespace + "/getItem", {
                id: external_maintenance_id,
              });
            });
        }
      }

      if (this.form.control_certificate && typeof this.form.control_certificate == "object" && this.form.control_certificate.type) {
        // Si il ne s'agit pas d'un fichier déjà présent
        let item = {
          external_maintenance_id: response.data.object.id,
          type_slug: "external-maintenance-certificate",
          format: this.form.control_certificate.type,
          file: this.form.control_certificate,
        };

        this.$store.dispatch("stored_file/addItem", item).then((response) => {
          this.$store.dispatch(config.storeNamespace + "/getItem", {
            id: external_maintenance_id,
          });
        });
      }

      ////

      // Si il ya des fichiers
      if (this.form.stored_files) {
        this.form.stored_files.forEach(fileLine => {
          // Si il ne s'agit pas d'un fichier déjà présent
          if (!fileLine.id) {
            let item = {
              external_maintenance_id: response.data.object.id,
              type_slug: "external-maintenance-attachment",
              format: fileLine.file.type,
              file: fileLine.file
            };

            this.$store.dispatch("stored_file/addItem", item);
          }
        });

        // Gestion des fichiers supprimés
        // On compare les données du formulaire avant modification avec mes données modifiées
        // pour identifier les fichiers supprimés
        if (this.initialForm.stored_files) {
          this.initialForm.stored_files.forEach(fileLine => {
            // Si le fichiers courant n'est plus dans les fichiers du formulaire, c'est qu'il faut le supprimer
            if (!this.form.stored_files.find(item => item.id == fileLine.id)) {
              this.$store.dispatch("stored_file/deleteItem", fileLine.id);
            }
          });
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ExternalMaintenance/ExternalMaintenanceForm.vue